import Contact from "../components/Contact";
import Seperator from "../components/Seperator";

export default function ContactUs() {
    return ( 
        <>
            <Contact />
            <Seperator />
        </>
    );
}